/**
 * enum of TrafficNode types
 * @default ANY
 */
export var TRAFFICNODE_TYPE;
(function (TRAFFICNODE_TYPE) {
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["ANY"] = 0] = "ANY";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["STOP"] = 1] = "STOP";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["POI"] = 2] = "POI";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["ADDRESS"] = 3] = "ADDRESS";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["COORDS"] = 4] = "COORDS";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["BIKE"] = 5] = "BIKE";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["P_AND_R"] = 6] = "P_AND_R";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["CARSHARING"] = 7] = "CARSHARING";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["CARSHARING_STADTFLITZER"] = 8] = "CARSHARING_STADTFLITZER";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["CARSHARING_STADTMOBIL"] = 9] = "CARSHARING_STADTMOBIL";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["CARSHARING_GREENWHEELS"] = 10] = "CARSHARING_GREENWHEELS";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["TICKETMACHINE"] = 11] = "TICKETMACHINE";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["PLATFORM"] = 12] = "PLATFORM";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["W3W"] = 13] = "W3W";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["PLUSCODES"] = 14] = "PLUSCODES";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["PLACE"] = 15] = "PLACE";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["CAR_CHARGING_STATION"] = 16] = "CAR_CHARGING_STATION";
    TRAFFICNODE_TYPE[TRAFFICNODE_TYPE["PARKING"] = 17] = "PARKING";
})(TRAFFICNODE_TYPE || (TRAFFICNODE_TYPE = {}));
/** enum of possible data origins for a traffic node search */
export var TRAFFICNODE_SOURCE;
(function (TRAFFICNODE_SOURCE) {
    TRAFFICNODE_SOURCE[TRAFFICNODE_SOURCE["ANY"] = 0] = "ANY";
    TRAFFICNODE_SOURCE[TRAFFICNODE_SOURCE["STRING_SEARCH"] = 1] = "STRING_SEARCH";
    TRAFFICNODE_SOURCE[TRAFFICNODE_SOURCE["LOCATION_SEARCH"] = 2] = "LOCATION_SEARCH";
})(TRAFFICNODE_SOURCE || (TRAFFICNODE_SOURCE = {}));
/**
 * enum of Mot types
 * @default ANY
 */
export var MOT_TYPE;
(function (MOT_TYPE) {
    MOT_TYPE[MOT_TYPE["ANY"] = 0] = "ANY";
    MOT_TYPE[MOT_TYPE["TRAM"] = 1] = "TRAM";
    MOT_TYPE[MOT_TYPE["LIGHTRAIL"] = 2] = "LIGHTRAIL";
    MOT_TYPE[MOT_TYPE["SUBWAY"] = 3] = "SUBWAY";
    MOT_TYPE[MOT_TYPE["BUS"] = 4] = "BUS";
    MOT_TYPE[MOT_TYPE["BUS_EXPRESS"] = 5] = "BUS_EXPRESS";
    MOT_TYPE[MOT_TYPE["BUS_CITYBUS"] = 6] = "BUS_CITYBUS";
    MOT_TYPE[MOT_TYPE["BUS_REGIONAL"] = 7] = "BUS_REGIONAL";
    MOT_TYPE[MOT_TYPE["BUS_INTERCITY"] = 8] = "BUS_INTERCITY";
    MOT_TYPE[MOT_TYPE["BUS_NIGHTLINE"] = 9] = "BUS_NIGHTLINE";
    MOT_TYPE[MOT_TYPE["EXPRESSBUS"] = 10] = "EXPRESSBUS";
    MOT_TYPE[MOT_TYPE["TRAIN"] = 11] = "TRAIN";
    MOT_TYPE[MOT_TYPE["TRAIN_URBAN"] = 12] = "TRAIN_URBAN";
    MOT_TYPE[MOT_TYPE["TRAIN_ICE"] = 13] = "TRAIN_ICE";
    MOT_TYPE[MOT_TYPE["TRAIN_IC"] = 14] = "TRAIN_IC";
    MOT_TYPE[MOT_TYPE["TRAIN_RE"] = 15] = "TRAIN_RE";
    MOT_TYPE[MOT_TYPE["HAILEDSHAREDTAXI"] = 16] = "HAILEDSHAREDTAXI";
    MOT_TYPE[MOT_TYPE["TAXI"] = 17] = "TAXI";
    MOT_TYPE[MOT_TYPE["BIKE"] = 18] = "BIKE";
    MOT_TYPE[MOT_TYPE["WALKING"] = 19] = "WALKING";
    MOT_TYPE[MOT_TYPE["CAR"] = 20] = "CAR";
    MOT_TYPE[MOT_TYPE["CARSHARING"] = 21] = "CARSHARING";
    MOT_TYPE[MOT_TYPE["CARSHARING_STADTFLITZER"] = 22] = "CARSHARING_STADTFLITZER";
    MOT_TYPE[MOT_TYPE["CARSHARING_STADTMOBIL"] = 23] = "CARSHARING_STADTMOBIL";
    MOT_TYPE[MOT_TYPE["CARSHARING_GREENWHEELS"] = 24] = "CARSHARING_GREENWHEELS";
    MOT_TYPE[MOT_TYPE["FERRY"] = 25] = "FERRY";
    MOT_TYPE[MOT_TYPE["CABLEWAY"] = 26] = "CABLEWAY";
    MOT_TYPE[MOT_TYPE["OTHER"] = 27] = "OTHER";
})(MOT_TYPE || (MOT_TYPE = {}));
/**
 * enum of charging station plug types
 * @default UNKNOWN
 */
export var CHARGING_STATION_PLUG_TYPE;
(function (CHARGING_STATION_PLUG_TYPE) {
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["ANY"] = 0] = "ANY";
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["UNKNOWN"] = 1] = "UNKNOWN";
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["TYPE_1"] = 2] = "TYPE_1";
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["TYPE_2"] = 3] = "TYPE_2";
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["COMBO"] = 4] = "COMBO";
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["SCHUKO"] = 5] = "SCHUKO";
    CHARGING_STATION_PLUG_TYPE[CHARGING_STATION_PLUG_TYPE["CHADEMO"] = 6] = "CHADEMO";
})(CHARGING_STATION_PLUG_TYPE || (CHARGING_STATION_PLUG_TYPE = {}));
export var CHARGING_STATION_USAGE_REQUIREMENT;
(function (CHARGING_STATION_USAGE_REQUIREMENT) {
    CHARGING_STATION_USAGE_REQUIREMENT[CHARGING_STATION_USAGE_REQUIREMENT["PAY_AT_LOCATION"] = 0] = "PAY_AT_LOCATION";
    CHARGING_STATION_USAGE_REQUIREMENT[CHARGING_STATION_USAGE_REQUIREMENT["MEMBERSHIP_REQUIRED"] = 1] = "MEMBERSHIP_REQUIRED";
    CHARGING_STATION_USAGE_REQUIREMENT[CHARGING_STATION_USAGE_REQUIREMENT["ACCESS_KEY_REQUIRED"] = 2] = "ACCESS_KEY_REQUIRED";
    CHARGING_STATION_USAGE_REQUIREMENT[CHARGING_STATION_USAGE_REQUIREMENT["UNKNOWN"] = 3] = "UNKNOWN";
})(CHARGING_STATION_USAGE_REQUIREMENT || (CHARGING_STATION_USAGE_REQUIREMENT = {}));
export var CHARGING_STATION_OPERATIONAL_STATUS;
(function (CHARGING_STATION_OPERATIONAL_STATUS) {
    CHARGING_STATION_OPERATIONAL_STATUS[CHARGING_STATION_OPERATIONAL_STATUS["NO_INFO"] = 0] = "NO_INFO";
    CHARGING_STATION_OPERATIONAL_STATUS[CHARGING_STATION_OPERATIONAL_STATUS["OPERATIONAL"] = 1] = "OPERATIONAL";
    CHARGING_STATION_OPERATIONAL_STATUS[CHARGING_STATION_OPERATIONAL_STATUS["NON_OPERATIONAL"] = 2] = "NON_OPERATIONAL";
    CHARGING_STATION_OPERATIONAL_STATUS[CHARGING_STATION_OPERATIONAL_STATUS["PARTIALLY_OPERATIONAL"] = 3] = "PARTIALLY_OPERATIONAL";
})(CHARGING_STATION_OPERATIONAL_STATUS || (CHARGING_STATION_OPERATIONAL_STATUS = {}));
export var CHARGING_STATION_ACCESS_TYPE;
(function (CHARGING_STATION_ACCESS_TYPE) {
    CHARGING_STATION_ACCESS_TYPE[CHARGING_STATION_ACCESS_TYPE["PRIVATE"] = 0] = "PRIVATE";
    CHARGING_STATION_ACCESS_TYPE[CHARGING_STATION_ACCESS_TYPE["PRIVATE_WITH_PUBLIC_ACCESS"] = 1] = "PRIVATE_WITH_PUBLIC_ACCESS";
    CHARGING_STATION_ACCESS_TYPE[CHARGING_STATION_ACCESS_TYPE["PUBLIC"] = 2] = "PUBLIC";
    CHARGING_STATION_ACCESS_TYPE[CHARGING_STATION_ACCESS_TYPE["UNKNOWN"] = 3] = "UNKNOWN";
})(CHARGING_STATION_ACCESS_TYPE || (CHARGING_STATION_ACCESS_TYPE = {}));
/**
 * enum of Transition types
 * e.g. Walking, Stairs, Elevators
 * @default ANY
 */
export var TRANSITION_TYPE;
(function (TRANSITION_TYPE) {
    TRANSITION_TYPE[TRANSITION_TYPE["ANY"] = 0] = "ANY";
    TRANSITION_TYPE[TRANSITION_TYPE["WALKING"] = 1] = "WALKING";
    TRANSITION_TYPE[TRANSITION_TYPE["STAIRS_UP"] = 2] = "STAIRS_UP";
    TRANSITION_TYPE[TRANSITION_TYPE["STAIRS_DOWN"] = 3] = "STAIRS_DOWN";
    TRANSITION_TYPE[TRANSITION_TYPE["ELEVATOR_UP"] = 4] = "ELEVATOR_UP";
    TRANSITION_TYPE[TRANSITION_TYPE["ELEVATOR_DOWN"] = 5] = "ELEVATOR_DOWN";
    TRANSITION_TYPE[TRANSITION_TYPE["ESCALATOR_UP"] = 6] = "ESCALATOR_UP";
    TRANSITION_TYPE[TRANSITION_TYPE["ESCALATOR_DOWN"] = 7] = "ESCALATOR_DOWN";
    TRANSITION_TYPE[TRANSITION_TYPE["RAMP_UP"] = 8] = "RAMP_UP";
    TRANSITION_TYPE[TRANSITION_TYPE["RAMP_DOWN"] = 9] = "RAMP_DOWN";
    TRANSITION_TYPE[TRANSITION_TYPE["STAY_IN_VEHICLE"] = 10] = "STAY_IN_VEHICLE";
    TRANSITION_TYPE[TRANSITION_TYPE["CHANGE_VEHICLES"] = 11] = "CHANGE_VEHICLES";
    TRANSITION_TYPE[TRANSITION_TYPE["ENSURED_CONNECTION"] = 12] = "ENSURED_CONNECTION";
})(TRANSITION_TYPE || (TRANSITION_TYPE = {}));
/**
 * enum of two categories of mot:
 * Mot and Transition
 * @default ANY
 */
export var TRANSPORTATION_CATEGORY;
(function (TRANSPORTATION_CATEGORY) {
    TRANSPORTATION_CATEGORY[TRANSPORTATION_CATEGORY["MOT"] = 0] = "MOT";
    TRANSPORTATION_CATEGORY[TRANSPORTATION_CATEGORY["TRANSITION"] = 1] = "TRANSITION";
})(TRANSPORTATION_CATEGORY || (TRANSPORTATION_CATEGORY = {}));
/**
 * Enum of the possible positions of a transition that belongs to a
 * PartialConnection. Before the PT, after it, or 'instead' of it
 * @default AFTER
 */
export var TRANSITION_SEQUENCE;
(function (TRANSITION_SEQUENCE) {
    TRANSITION_SEQUENCE[TRANSITION_SEQUENCE["BEFORE"] = 0] = "BEFORE";
    TRANSITION_SEQUENCE[TRANSITION_SEQUENCE["AFTER"] = 1] = "AFTER";
    TRANSITION_SEQUENCE[TRANSITION_SEQUENCE["MAIN"] = 2] = "MAIN"; // the transition is the mot itself, instead of coming before or after
})(TRANSITION_SEQUENCE || (TRANSITION_SEQUENCE = {}));
/**
 * enum of MapProjections
 * @default GK4
 */
export var MAP_PROJECTION;
(function (MAP_PROJECTION) {
    MAP_PROJECTION[MAP_PROJECTION["GK4"] = 0] = "GK4";
    MAP_PROJECTION[MAP_PROJECTION["WGS84"] = 1] = "WGS84";
})(MAP_PROJECTION || (MAP_PROJECTION = {}));
/**
 * enum of distances from current location to TrafficNode
 * @default ANY
 */
export var MAX_DISTANCE;
(function (MAX_DISTANCE) {
    MAX_DISTANCE[MAX_DISTANCE["ANY"] = 0] = "ANY";
    MAX_DISTANCE[MAX_DISTANCE["DISTANCEFIVEMIN"] = 5] = "DISTANCEFIVEMIN";
    MAX_DISTANCE[MAX_DISTANCE["DISTANCETENMIN"] = 10] = "DISTANCETENMIN";
    MAX_DISTANCE[MAX_DISTANCE["DISTANCEFIFTEENMIN"] = 15] = "DISTANCEFIFTEENMIN";
    MAX_DISTANCE[MAX_DISTANCE["DISTANCETWENTYMIN"] = 20] = "DISTANCETWENTYMIN";
    MAX_DISTANCE[MAX_DISTANCE["DISTANCETHIRTYMIN"] = 30] = "DISTANCETHIRTYMIN";
})(MAX_DISTANCE || (MAX_DISTANCE = {}));
/**
 * enum of predefined walking speed
 * @default NORMAL
 */
export var WALKING_SPEED;
(function (WALKING_SPEED) {
    WALKING_SPEED[WALKING_SPEED["NORMAL"] = 0] = "NORMAL";
    WALKING_SPEED[WALKING_SPEED["VERYSLOW"] = 1] = "VERYSLOW";
    WALKING_SPEED[WALKING_SPEED["SLOW"] = 2] = "SLOW";
    WALKING_SPEED[WALKING_SPEED["FAST"] = 3] = "FAST";
    WALKING_SPEED[WALKING_SPEED["VERYFAST"] = 4] = "VERYFAST";
})(WALKING_SPEED || (WALKING_SPEED = {}));
/**
 * describes the number of maximum mot changes during connections or travels from stations
 * @default ANY
 */
export var MAX_CHANGE;
(function (MAX_CHANGE) {
    MAX_CHANGE[MAX_CHANGE["ANY"] = 0] = "ANY";
    MAX_CHANGE[MAX_CHANGE["NONE"] = 1] = "NONE";
    MAX_CHANGE[MAX_CHANGE["ONE"] = 2] = "ONE";
    MAX_CHANGE[MAX_CHANGE["TWO"] = 3] = "TWO";
    MAX_CHANGE[MAX_CHANGE["THREE"] = 4] = "THREE";
})(MAX_CHANGE || (MAX_CHANGE = {}));
/**
 * describes categories for MOTs
 * @default ANY
 */
export var MOT_CATEGORY;
(function (MOT_CATEGORY) {
    MOT_CATEGORY[MOT_CATEGORY["ANY"] = 0] = "ANY";
    MOT_CATEGORY[MOT_CATEGORY["LOCAL"] = 1] = "LOCAL";
    MOT_CATEGORY[MOT_CATEGORY["LONGDISTANCE"] = 2] = "LONGDISTANCE";
})(MOT_CATEGORY || (MOT_CATEGORY = {}));
/**
 * describes any mobility impairments e.g. stroller or wheelchair use
 * @default NONE
 */
export var MOBILITY_IMPAIRMENT;
(function (MOBILITY_IMPAIRMENT) {
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["NONE"] = 0] = "NONE";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["NOSTAIRS"] = 1] = "NOSTAIRS";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["NOESCALATORS"] = 2] = "NOESCALATORS";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["NOELEVATORS"] = 3] = "NOELEVATORS";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["WALKINGIMPAIRED"] = 4] = "WALKINGIMPAIRED";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["UNAIDEDWHEELCHAIR"] = 5] = "UNAIDEDWHEELCHAIR";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["SINGLESTROLLER"] = 6] = "SINGLESTROLLER";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["DOUBLESTROLLER"] = 7] = "DOUBLESTROLLER";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["ONLYLOWPLATFORM"] = 8] = "ONLYLOWPLATFORM";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["ONLYWITHLIFTINGDEVICE"] = 9] = "ONLYWITHLIFTINGDEVICE";
    MOBILITY_IMPAIRMENT[MOBILITY_IMPAIRMENT["BIKE_TAKEALONG"] = 10] = "BIKE_TAKEALONG";
})(MOBILITY_IMPAIRMENT || (MOBILITY_IMPAIRMENT = {}));
/**
 * describes any line selection
 * @default ANY
 */
export var LINE_SELECTION;
(function (LINE_SELECTION) {
    LINE_SELECTION[LINE_SELECTION["ANY"] = 0] = "ANY";
    LINE_SELECTION[LINE_SELECTION["NOINTERCITYEXPRESS"] = 1] = "NOINTERCITYEXPRESS";
    LINE_SELECTION[LINE_SELECTION["LOCALTRANSPORT"] = 2] = "LOCALTRANSPORT";
})(LINE_SELECTION || (LINE_SELECTION = {}));
/**
 * describes entrance height to any MOT
 * @default ANY
 */
export var ENTRANCE_HEIGHT;
(function (ENTRANCE_HEIGHT) {
    ENTRANCE_HEIGHT[ENTRANCE_HEIGHT["ANY"] = 0] = "ANY";
    ENTRANCE_HEIGHT[ENTRANCE_HEIGHT["SMALLSTEP"] = 1] = "SMALLSTEP";
    ENTRANCE_HEIGHT[ENTRANCE_HEIGHT["WITHOUTSTEP"] = 2] = "WITHOUTSTEP";
})(ENTRANCE_HEIGHT || (ENTRANCE_HEIGHT = {}));
/**
 * describes types of platform for departures
 * @default ANY
 */
export var PLATFORM_TYPE;
(function (PLATFORM_TYPE) {
    PLATFORM_TYPE[PLATFORM_TYPE["ANY"] = 0] = "ANY";
    PLATFORM_TYPE[PLATFORM_TYPE["PLATFORM"] = 1] = "PLATFORM";
    PLATFORM_TYPE[PLATFORM_TYPE["RAILTRACK"] = 2] = "RAILTRACK";
})(PLATFORM_TYPE || (PLATFORM_TYPE = {}));
/**
 * represents the languages used in this app
 */
export var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE[LANGUAGE["ANY"] = 0] = "ANY";
    LANGUAGE[LANGUAGE["DE"] = 1] = "DE";
    LANGUAGE[LANGUAGE["EN"] = 2] = "EN";
    LANGUAGE[LANGUAGE["IT"] = 3] = "IT";
    LANGUAGE[LANGUAGE["LAD"] = 4] = "LAD";
    LANGUAGE[LANGUAGE["TUR"] = 5] = "TUR";
    LANGUAGE[LANGUAGE["CZE"] = 6] = "CZE";
})(LANGUAGE || (LANGUAGE = {}));
export var MULTI_MODALITY_TYPE;
(function (MULTI_MODALITY_TYPE) {
    MULTI_MODALITY_TYPE[MULTI_MODALITY_TYPE["TAXI"] = 0] = "TAXI";
    MULTI_MODALITY_TYPE[MULTI_MODALITY_TYPE["BICYCLE"] = 1] = "BICYCLE";
    MULTI_MODALITY_TYPE[MULTI_MODALITY_TYPE["STADTMOBIL"] = 2] = "STADTMOBIL";
    MULTI_MODALITY_TYPE[MULTI_MODALITY_TYPE["STADTFLITZER"] = 3] = "STADTFLITZER";
    MULTI_MODALITY_TYPE[MULTI_MODALITY_TYPE["ONFOOT"] = 4] = "ONFOOT";
})(MULTI_MODALITY_TYPE || (MULTI_MODALITY_TYPE = {}));
/**
 * Types of cars on a given carsharing station
 */
export var CAR_TYPE;
(function (CAR_TYPE) {
    CAR_TYPE[CAR_TYPE["ANY"] = 0] = "ANY";
    CAR_TYPE[CAR_TYPE["TWO_DOOR"] = 1] = "TWO_DOOR";
    CAR_TYPE[CAR_TYPE["FOUR_DOOR"] = 2] = "FOUR_DOOR";
    CAR_TYPE[CAR_TYPE["STATION_WAGON"] = 3] = "STATION_WAGON";
    CAR_TYPE[CAR_TYPE["MINIVAN"] = 4] = "MINIVAN";
    CAR_TYPE[CAR_TYPE["COUPE"] = 5] = "COUPE";
})(CAR_TYPE || (CAR_TYPE = {}));
/**
 * Enum of the three possible states of nodes in a line.
 * PREVIOUS for stops before your searched point
 * CURRENT for the stop you searched for
 * ONWARD for the stops the mot will come next in the yourney
 */
export var STOP_SEQUENCE;
(function (STOP_SEQUENCE) {
    STOP_SEQUENCE[STOP_SEQUENCE["PREVIOUS"] = 0] = "PREVIOUS";
    STOP_SEQUENCE[STOP_SEQUENCE["CURRENT"] = 1] = "CURRENT";
    STOP_SEQUENCE[STOP_SEQUENCE["ONWARD"] = 2] = "ONWARD";
})(STOP_SEQUENCE || (STOP_SEQUENCE = {}));
/**
 * Enum of possible traffic message type
 * DISRUPTION General disruption, mostly unforeseen
 * CONSTRUCTION Longer lasting traffic messages because of
 * construction sites
 * EVENT Info Messages about events that change the flow of traffic
 * BANNER Usually displayed in seperate boxes, used for events or urgent messages
 */
export var DISRUPTION_TYPE;
(function (DISRUPTION_TYPE) {
    DISRUPTION_TYPE[DISRUPTION_TYPE["DISRUPTION"] = 0] = "DISRUPTION";
    DISRUPTION_TYPE[DISRUPTION_TYPE["CONSTRUCTION"] = 1] = "CONSTRUCTION";
    DISRUPTION_TYPE[DISRUPTION_TYPE["EVENT"] = 2] = "EVENT";
    DISRUPTION_TYPE[DISRUPTION_TYPE["BANNER"] = 3] = "BANNER";
})(DISRUPTION_TYPE || (DISRUPTION_TYPE = {}));
/**
 * A set of possible priority ratings for disruptions
 */
export var DISRUPTION_PRIORITY;
(function (DISRUPTION_PRIORITY) {
    DISRUPTION_PRIORITY[DISRUPTION_PRIORITY["LOW"] = 0] = "LOW";
    DISRUPTION_PRIORITY[DISRUPTION_PRIORITY["NORMAL"] = 1] = "NORMAL";
    DISRUPTION_PRIORITY[DISRUPTION_PRIORITY["HIGH"] = 2] = "HIGH";
    DISRUPTION_PRIORITY[DISRUPTION_PRIORITY["URGENT"] = 3] = "URGENT";
})(DISRUPTION_PRIORITY || (DISRUPTION_PRIORITY = {}));
/**
 * Enum of possible error codes
 */
export var ERROR_CODE;
(function (ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["GENERAL_SERVER_ERROR"] = 0] = "GENERAL_SERVER_ERROR";
    ERROR_CODE[ERROR_CODE["CONNECTIONS_ERROR_NO_RESULTS"] = 1] = "CONNECTIONS_ERROR_NO_RESULTS";
    ERROR_CODE[ERROR_CODE["TIMETABLES_ERROR_NO_RESULTS"] = 2] = "TIMETABLES_ERROR_NO_RESULTS";
    ERROR_CODE[ERROR_CODE["TRAFFICNODE_ERROR_NO_RESULTS"] = 3] = "TRAFFICNODE_ERROR_NO_RESULTS";
    ERROR_CODE[ERROR_CODE["DATE_TIME_ERROR"] = 4] = "DATE_TIME_ERROR";
})(ERROR_CODE || (ERROR_CODE = {}));
/**
 * Enum of possible event types
 */
export var EVENT_CATEGORY;
(function (EVENT_CATEGORY) {
    EVENT_CATEGORY[EVENT_CATEGORY["ART"] = 0] = "ART";
    EVENT_CATEGORY[EVENT_CATEGORY["CABARET"] = 1] = "CABARET";
    EVENT_CATEGORY[EVENT_CATEGORY["CINEMA"] = 2] = "CINEMA";
    EVENT_CATEGORY[EVENT_CATEGORY["COMEDY"] = 3] = "COMEDY";
    EVENT_CATEGORY[EVENT_CATEGORY["CONCERT"] = 4] = "CONCERT";
    EVENT_CATEGORY[EVENT_CATEGORY["FAIR"] = 5] = "FAIR";
    EVENT_CATEGORY[EVENT_CATEGORY["LITERATURE"] = 6] = "LITERATURE";
    EVENT_CATEGORY[EVENT_CATEGORY["OTHER"] = 7] = "OTHER";
    EVENT_CATEGORY[EVENT_CATEGORY["PARTY"] = 8] = "PARTY";
    EVENT_CATEGORY[EVENT_CATEGORY["SHOW"] = 9] = "SHOW";
    EVENT_CATEGORY[EVENT_CATEGORY["SPORT"] = 10] = "SPORT";
    EVENT_CATEGORY[EVENT_CATEGORY["THEATRE"] = 11] = "THEATRE";
})(EVENT_CATEGORY || (EVENT_CATEGORY = {}));
/**
 * Enum of points of interest
 */
export var POI_TYPE;
(function (POI_TYPE) {
    POI_TYPE[POI_TYPE["SERVICE_CENTER"] = 0] = "SERVICE_CENTER";
    POI_TYPE[POI_TYPE["TICKET_AGENCY"] = 1] = "TICKET_AGENCY";
    POI_TYPE[POI_TYPE["TICKET_MACHINE"] = 2] = "TICKET_MACHINE";
    POI_TYPE[POI_TYPE["BIKE_AND_RIDE"] = 3] = "BIKE_AND_RIDE";
    POI_TYPE[POI_TYPE["BIKE_RENTAL"] = 4] = "BIKE_RENTAL";
    POI_TYPE[POI_TYPE["PARK_AND_RIDE"] = 5] = "PARK_AND_RIDE";
    POI_TYPE[POI_TYPE["ELECTRIC_CAR_LOADING_STATION"] = 6] = "ELECTRIC_CAR_LOADING_STATION";
    POI_TYPE[POI_TYPE["PARKING"] = 7] = "PARKING";
    POI_TYPE[POI_TYPE["CAR_SHARING"] = 8] = "CAR_SHARING";
    POI_TYPE[POI_TYPE["TAXI_LOCATION"] = 9] = "TAXI_LOCATION";
    POI_TYPE[POI_TYPE["ADMINISTRATION"] = 10] = "ADMINISTRATION";
    POI_TYPE[POI_TYPE["LIBRARY"] = 11] = "LIBRARY";
    POI_TYPE[POI_TYPE["COURT"] = 12] = "COURT";
    POI_TYPE[POI_TYPE["CEMETERY"] = 13] = "CEMETERY";
    POI_TYPE[POI_TYPE["RELIGION"] = 14] = "RELIGION";
    POI_TYPE[POI_TYPE["POST"] = 15] = "POST";
    POI_TYPE[POI_TYPE["POLICE"] = 16] = "POLICE";
    POI_TYPE[POI_TYPE["KINDERGARTEN"] = 17] = "KINDERGARTEN";
    POI_TYPE[POI_TYPE["EDUCATION_INSTITUTION"] = 18] = "EDUCATION_INSTITUTION";
    POI_TYPE[POI_TYPE["UNIVERSITY"] = 19] = "UNIVERSITY";
    POI_TYPE[POI_TYPE["HOSPITAL"] = 20] = "HOSPITAL";
    POI_TYPE[POI_TYPE["DOCTOR"] = 21] = "DOCTOR";
    POI_TYPE[POI_TYPE["ANIMAL_PARK"] = 22] = "ANIMAL_PARK";
    POI_TYPE[POI_TYPE["THEATER"] = 23] = "THEATER";
    POI_TYPE[POI_TYPE["CINEMA"] = 24] = "CINEMA";
    POI_TYPE[POI_TYPE["VENUES"] = 25] = "VENUES";
    POI_TYPE[POI_TYPE["YOUTH_CENTER"] = 26] = "YOUTH_CENTER";
    POI_TYPE[POI_TYPE["SIGHTS"] = 27] = "SIGHTS";
    POI_TYPE[POI_TYPE["MUSEUM"] = 28] = "MUSEUM";
    POI_TYPE[POI_TYPE["PARK"] = 29] = "PARK";
    POI_TYPE[POI_TYPE["BATH"] = 30] = "BATH";
    POI_TYPE[POI_TYPE["LAKES"] = 31] = "LAKES";
    POI_TYPE[POI_TYPE["SPORT_FACILITY"] = 32] = "SPORT_FACILITY";
    POI_TYPE[POI_TYPE["HOTEL"] = 33] = "HOTEL";
    POI_TYPE[POI_TYPE["HOSTEL"] = 34] = "HOSTEL";
    POI_TYPE[POI_TYPE["STUDENT_RESIDENCE"] = 35] = "STUDENT_RESIDENCE";
})(POI_TYPE || (POI_TYPE = {}));
/**
 * Enum of the route types for a connection
 */
export var ROUTE_TYPE;
(function (ROUTE_TYPE) {
    ROUTE_TYPE[ROUTE_TYPE["LEAST_TIME"] = 0] = "LEAST_TIME";
    ROUTE_TYPE[ROUTE_TYPE["LEAST_CHANGES"] = 1] = "LEAST_CHANGES";
    ROUTE_TYPE[ROUTE_TYPE["LEAST_WALKING"] = 2] = "LEAST_WALKING";
})(ROUTE_TYPE || (ROUTE_TYPE = {}));
/**
 * Enum of the different major weather states
 */
export var WEATHER_TYPE;
(function (WEATHER_TYPE) {
    WEATHER_TYPE[WEATHER_TYPE["SUNNY"] = 0] = "SUNNY";
    WEATHER_TYPE[WEATHER_TYPE["PARTLY_CLOUDY"] = 1] = "PARTLY_CLOUDY";
    WEATHER_TYPE[WEATHER_TYPE["VERY_CLOUDY"] = 2] = "VERY_CLOUDY";
    WEATHER_TYPE[WEATHER_TYPE["RAIN"] = 3] = "RAIN";
    WEATHER_TYPE[WEATHER_TYPE["SNOW"] = 4] = "SNOW";
    WEATHER_TYPE[WEATHER_TYPE["FOG"] = 5] = "FOG";
    WEATHER_TYPE[WEATHER_TYPE["THUNDERSTORM"] = 6] = "THUNDERSTORM";
})(WEATHER_TYPE || (WEATHER_TYPE = {}));
/**
 * Enum of different types of operation in turn by turn navigation.
 */
export var TURN_BY_TURN_TYPE;
(function (TURN_BY_TURN_TYPE) {
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["GO"] = 0] = "GO";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["TURN"] = 1] = "TURN";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["STAIRS"] = 2] = "STAIRS";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["ELEVATOR"] = 3] = "ELEVATOR";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["ESCALATOR"] = 4] = "ESCALATOR";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["RAMP"] = 5] = "RAMP";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["ENTER"] = 6] = "ENTER";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["LEAVE"] = 7] = "LEAVE";
    TURN_BY_TURN_TYPE[TURN_BY_TURN_TYPE["UNKNOWN"] = 8] = "UNKNOWN";
})(TURN_BY_TURN_TYPE || (TURN_BY_TURN_TYPE = {}));
/**
 * Enum of different directions for operation in turn by turn navigation.
 */
export var TURN_BY_TURN_DIRECTION;
(function (TURN_BY_TURN_DIRECTION) {
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["STRAIGHT"] = 0] = "STRAIGHT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["SLIGHT_RIGHT"] = 1] = "SLIGHT_RIGHT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["RIGHT"] = 2] = "RIGHT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["SHARP_RIGHT"] = 3] = "SHARP_RIGHT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["SLIGHT_LEFT"] = 4] = "SLIGHT_LEFT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["LEFT"] = 5] = "LEFT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["SHARP_LEFT"] = 6] = "SHARP_LEFT";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["BACK"] = 7] = "BACK";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["UP"] = 8] = "UP";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["DOWN"] = 9] = "DOWN";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["U_TURN"] = 10] = "U_TURN";
    TURN_BY_TURN_DIRECTION[TURN_BY_TURN_DIRECTION["UNKNOWN"] = 11] = "UNKNOWN";
})(TURN_BY_TURN_DIRECTION || (TURN_BY_TURN_DIRECTION = {}));
/**
 * Enum of ticket types
 */
export var TICKET_TYPE;
(function (TICKET_TYPE) {
    TICKET_TYPE[TICKET_TYPE["SINGLE"] = 0] = "SINGLE";
    TICKET_TYPE[TICKET_TYPE["SUBSCRIPTION"] = 1] = "SUBSCRIPTION";
})(TICKET_TYPE || (TICKET_TYPE = {}));
/**
 * Enum of requirement types for tickets
 */
export var TICKET_REQUIREMENT;
(function (TICKET_REQUIREMENT) {
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_ADULTS"] = 0] = "NUMBER_OF_ADULTS";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_CHILDREN"] = 1] = "NUMBER_OF_CHILDREN";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_PERSONS"] = 2] = "NUMBER_OF_PERSONS";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_PUPILS"] = 3] = "NUMBER_OF_PUPILS";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_BIKES"] = 4] = "NUMBER_OF_BIKES";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_PASSED_ZONES"] = 5] = "NUMBER_OF_PASSED_ZONES";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_DRIVEN_DISTANCE"] = 6] = "NUMBER_OF_DRIVEN_DISTANCE";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["NUMBER_OF_TICKETS"] = 7] = "NUMBER_OF_TICKETS";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["START_ZONE"] = 8] = "START_ZONE";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["END_ZONE"] = 9] = "END_ZONE";
    TICKET_REQUIREMENT[TICKET_REQUIREMENT["VALID_FROM"] = 10] = "VALID_FROM";
})(TICKET_REQUIREMENT || (TICKET_REQUIREMENT = {}));
/**
 * Enum of occupancy types descriping the passenger density
 * @default UNKNOWN
 */
export var OCCUPANCY_TYPE;
(function (OCCUPANCY_TYPE) {
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["EMPTY"] = 1] = "EMPTY";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["MANY_SEATS"] = 2] = "MANY_SEATS";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["FEW_SEATS"] = 3] = "FEW_SEATS";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["STANDING_ONLY"] = 4] = "STANDING_ONLY";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["CRUSHED_STANDING"] = 5] = "CRUSHED_STANDING";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["FULL"] = 6] = "FULL";
    OCCUPANCY_TYPE[OCCUPANCY_TYPE["NOT_ACCEPTING_PASSENGERS"] = 7] = "NOT_ACCEPTING_PASSENGERS";
})(OCCUPANCY_TYPE || (OCCUPANCY_TYPE = {}));
//# sourceMappingURL=model.enums.js.map